module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0115.jpg?v=4e732be8";